import { omitBy } from 'lodash';

export const omitUndefined = <T extends Record<string, unknown>>(obj: T): T =>
    omitBy(obj, (v: unknown) => v === undefined) as T;
